import de from 'flag-icons/flags/4x3/de.svg'
import gb from 'flag-icons/flags/4x3/gb.svg'
import ru from 'flag-icons/flags/4x3/ru.svg'
import tr from 'flag-icons/flags/4x3/tr.svg'
import ua from 'flag-icons/flags/4x3/ua.svg'
import sa from 'flag-icons/flags/4x3/sa.svg'
import il from 'flag-icons/flags/4x3/il.svg'
import pl from 'flag-icons/flags/4x3/pl.svg'
import fr from 'flag-icons/flags/4x3/fr.svg'
import by from 'flag-icons/flags/4x3/by.svg'
import ge from 'flag-icons/flags/4x3/ge.svg'
import ro from 'flag-icons/flags/4x3/ro.svg'
import ir from 'flag-icons/flags/4x3/ir.svg'
import it from 'flag-icons/flags/4x3/it.svg'

export const FLAGS = { de, gb, ru, tr, ua, sa, il, pl, fr, by, ge, ro, ir, it }
